
// 用户信息修改的相关请求封装
import request from '@/utils/request'

// 用户信息修改保存接口
export const saveInfo=(userDataRequest)=>{
    return request.post(
        '/submitModify',
        userDataRequest
    )
}

// 通过用户id查询用户信息
export const findUserByUserId=(userId)=>{
    return request.get(
        '/findUserByUserId',
        {
            params:{
                userId:userId
            }
        }
    )
}